module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/step3.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/step3.png
// module id = 488
// module chunks = 0